import React, { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { ToastContainer, toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import 'bootstrap/dist/css/bootstrap.min.css';

const About = () => {
  const navigate = useNavigate();
  const [loading, setLoading] = useState(true);
  
  // Company profile data
  const [companyProfile, setCompanyProfile] = useState({
    head_office: '',
    branch_office: '',
    phone1: '',
    phone2: '',
    website: '',
    email: '',
    address2: ''
  });

  // Check if user is logged in (optional - depends on your requirements)
  useEffect(() => {
    const isLoggedIn = localStorage.getItem('LoggedIn');
    if (!isLoggedIn || isLoggedIn !== '1') {
      // Uncomment if you want to require login for about page
      // toast.info('Please login to view this page');
      // navigate('/login');
      // return;
    }
    
    loadCompanyProfile();
  }, [navigate]);

  const loadCompanyProfile = async () => {
    try {
      setLoading(true);
      
      const url = 'https://fx4money.com/Rest/company_profile_api';
      const response = await fetch(url);
      const data = await response.json();
      
      setCompanyProfile({
        head_office: data.address1 || '',
        branch_office: data.address2 || '',
        phone1: data.phone1 || '',
        phone2: data.phone2 || '',
        website: data.website || '',
        email: data.email || '',
        address2: data.address2 || ''
      });
      
      setLoading(false);
    } catch (error) {
      console.error('Error loading company profile:', error);
      toast.error('Failed to load company information');
      setLoading(false);
    }
  };

  if (loading) {
    return (
      <div className="container-fluid bg-light min-vh-100 d-flex justify-content-center align-items-center">
        <div className="text-center">
          <div className="spinner-border text-primary" role="status">
            <span className="visually-hidden">Loading...</span>
          </div>
          <p className="mt-2">Loading company information...</p>
        </div>
      </div>
    );
  }

  return (
    <div className="container-fluid bg-light min-vh-100">
      <ToastContainer position="top-right" autoClose={3000} />
      
      {/* Header */}
      <nav className="navbar navbar-expand-lg navbar-dark bg-primary shadow">
        <div className="container-fluid">
          <div className="d-flex align-items-center">
            <button 
              className="btn btn-link text-white me-2"
              onClick={() => navigate(-1)}
            >
              <i className="bi bi-arrow-left fs-4"></i>
            </button>
            <h1 className="navbar-brand mb-0 h1 fs-4">About Company</h1>
          </div>
          <div>
            <button 
              className="btn btn-outline-light btn-sm"
              onClick={() => navigate('/')}
            >
              <i className="bi bi-house me-1"></i>
              Home
            </button>
          </div>
        </div>
      </nav>

      <div className="container py-5">
        {/* Hero Section */}
        <div className="text-center mb-5">
          <div className="mb-4">
            <div className="rounded-circle bg-primary bg-opacity-10 d-inline-flex align-items-center justify-content-center p-4">
              <i className="bi bi-building fs-1 text-primary"></i>
            </div>
          </div>
          <h1 className="fw-bold text-primary mb-3">About Our Company</h1>
          <p className="lead text-muted mx-auto" style={{ maxWidth: '600px' }}>
            We are committed to providing exceptional services with integrity, innovation, and customer satisfaction at our core.
          </p>
        </div>

        <div className="row justify-content-center">
          <div className="col-lg-10">
            {/* Company Overview */}
           

            {/* Contact Information */}
            <div className="row">
              {/* Head Office */}
              <div className="col-md-6 mb-4">
                <div className="card shadow-sm border-0 h-100">
                  <div className="card-header bg-white border-0">
                    <h5 className="card-title mb-0 fw-bold">
                      <i className="bi bi-building text-primary me-2"></i>
                      Head Office
                    </h5>
                  </div>
                  <div className="card-body">
                    {companyProfile.head_office ? (
                      <div>
                        <p className="mb-3">{companyProfile.head_office}</p>
                        <div className="d-flex align-items-center mb-2">
                          <i className="bi bi-telephone text-primary me-3"></i>
                          <span>{companyProfile.phone1 || 'Not available'}</span>
                        </div>
                        {companyProfile.phone2 && (
                          <div className="d-flex align-items-center mb-3">
                            <i className="bi bi-telephone text-primary me-3"></i>
                            <span>{companyProfile.phone2}</span>
                          </div>
                        )}
                      </div>
                    ) : (
                      <p className="text-muted mb-0">Head office information not available</p>
                    )}
                    
                    
                  </div>
                </div>
              </div>

              {/* Branch Office */}
              <div className="col-md-6 mb-4">
                <div className="card shadow-sm border-0 h-100">
                  <div className="card-header bg-white border-0">
                    <h5 className="card-title mb-0 fw-bold">
                      <i className="bi bi-buildings text-primary me-2"></i>
                      Branch Office
                    </h5>
                  </div>
                  <div className="card-body">
                    {companyProfile.address2 ? (
                      <div>
                        <p className="mb-3">{companyProfile.address2}</p>
                        <div className="d-flex align-items-center mb-2">
                          <i className="bi bi-telephone text-primary me-3"></i>
                          <span>{companyProfile.phone1 || 'Not available'}</span>
                        </div>
                        {companyProfile.phone2 && (
                          <div className="d-flex align-items-center mb-3">
                            <i className="bi bi-telephone text-primary me-3"></i>
                            <span>{companyProfile.phone2}</span>
                          </div>
                        )}
                      </div>
                    ) : (
                      <p className="text-muted mb-0">Branch office information not available</p>
                    )}
                    
                    
                  </div>
                </div>
              </div>
            </div>

            {/* Contact Details Card */}
            <div className="card shadow-sm border-0 mb-4">
              <div className="card-body">
                <h5 className="card-title fw-bold mb-4">
                  <i className="bi bi-envelope text-primary me-2"></i>
                  Contact Details
                </h5>
                <div className="row">
                  <div className="col-md-6 mb-3">
                    <div className="d-flex align-items-center">
                      <div className="flex-shrink-0">
                        <div className="rounded-circle bg-primary bg-opacity-10 p-2 me-3">
                          <i className="bi bi-envelope text-primary"></i>
                        </div>
                      </div>
                      <div className="flex-grow-1">
                        <h6 className="fw-bold mb-1">Email Address</h6>
                        {companyProfile.email ? (
                          <a 
                            href={`mailto:${companyProfile.email}`}
                            className="text-decoration-none"
                          >
                            {companyProfile.email}
                          </a>
                        ) : (
                          <span className="text-muted">Not available</span>
                        )}
                      </div>
                    </div>
                  </div>
                  
                  <div className="col-md-6 mb-3">
                    <div className="d-flex align-items-center">
                      <div className="flex-shrink-0">
                        <div className="rounded-circle bg-primary bg-opacity-10 p-2 me-3">
                          <i className="bi bi-globe text-primary"></i>
                        </div>
                      </div>
                      <div className="flex-grow-1">
                        <h6 className="fw-bold mb-1">Website</h6>
                        {companyProfile.website ? (
                          <a 
                            href={companyProfile.website.startsWith('http') ? companyProfile.website : `https://${companyProfile.website}`}
                            target="_blank"
                            rel="noopener noreferrer"
                            className="text-decoration-none"
                          >
                            {companyProfile.website}
                          </a>
                        ) : (
                          <span className="text-muted">Not available</span>
                        )}
                      </div>
                    </div>
                  </div>
                  
                  <div className="col-md-6 mb-3">
                    <div className="d-flex align-items-center">
                      <div className="flex-shrink-0">
                        <div className="rounded-circle bg-primary bg-opacity-10 p-2 me-3">
                          <i className="bi bi-telephone text-primary"></i>
                        </div>
                      </div>
                      <div className="flex-grow-1">
                        <h6 className="fw-bold mb-1">Primary Phone</h6>
                        {companyProfile.phone1 ? (
                          <a 
                            href={`tel:${companyProfile.phone1}`}
                            className="text-decoration-none"
                          >
                            {companyProfile.phone1}
                          </a>
                        ) : (
                          <span className="text-muted">Not available</span>
                        )}
                      </div>
                    </div>
                  </div>
                  
                  <div className="col-md-6 mb-3">
                    <div className="d-flex align-items-center">
                      <div className="flex-shrink-0">
                        <div className="rounded-circle bg-primary bg-opacity-10 p-2 me-3">
                          <i className="bi bi-telephone-plus text-primary"></i>
                        </div>
                      </div>
                      <div className="flex-grow-1">
                        <h6 className="fw-bold mb-1">Secondary Phone</h6>
                        {companyProfile.phone2 ? (
                          <a 
                            href={`tel:${companyProfile.phone2}`}
                            className="text-decoration-none"
                          >
                            {companyProfile.phone2}
                          </a>
                        ) : (
                          <span className="text-muted">Not available</span>
                        )}
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>

          

            {/* Operating Hours */}
            <div className="card shadow-sm border-0 mt-4">
              <div className="card-body">
                <h5 className="card-title fw-bold mb-4">
                  <i className="bi bi-clock text-primary me-2"></i>
                  Operating Hours
                </h5>
                <div className="row">
                  <div className="col-md-6">
                    <div className="table-responsive">
                      <table className="table table-borderless">
                        <tbody>
                          <tr>
                            <td className="fw-bold">Monday - Friday</td>
                            <td>9:00 AM - 6:00 PM</td>
                          </tr>
                          <tr>
                            <td className="fw-bold">Saturday</td>
                            <td>10:00 AM - 4:00 PM</td>
                          </tr>
                          <tr>
                            <td className="fw-bold">Sunday</td>
                            <td>Closed</td>
                          </tr>
                          <tr>
                            <td className="fw-bold">Public Holidays</td>
                            <td>Closed</td>
                          </tr>
                        </tbody>
                      </table>
                    </div>
                  </div>
                  <div className="col-md-6">
                    <div className="alert alert-info">
                      <i className="bi bi-info-circle me-2"></i>
                      <strong>Customer Support:</strong> Available 24/7 via email for urgent inquiries
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      {/* Footer */}
      <footer className="bg-dark text-white py-4 mt-4">
        <div className="container">
          <div className="row align-items-center">
            <div className="col-md-6">
              <h6 className="fw-bold mb-3">Our Company</h6>
              <p className="small opacity-75 mb-0">
                Committed to excellence and customer satisfaction since our establishment.
              </p>
            </div>
            <div className="col-md-6 text-md-end">
              <div className="mb-3">
                <small className="opacity-75">
                  © {new Date().getFullYear()} Our Company. All rights reserved.
                </small>
              </div>
              <div>
                <a href="/privacy" className="text-white opacity-75 me-3 text-decoration-none">Privacy Policy</a>
                <a href="/terms" className="text-white opacity-75 me-3 text-decoration-none">Terms of Service</a>
                <a href="/contact" className="text-white opacity-75 text-decoration-none">Contact Us</a>
              </div>
            </div>
          </div>
        </div>
      </footer>
    </div>
  );
};

export default About;